// @ts-nocheck

import { useKeyboardNavigation } from 'app/shared/modules/MobileSRP/Header/FilterBar/hooks';
import { useYieldCallback } from '@zillow/yield-callback';

// Tracking

export const useTravelDropdown = ({
  focusRef,
  refList,
  showDropdown,
  setShowDropdown,
  filterState,
  setFilterState,
  toggleDepartureDropdown,
}) => {
  // General keyboard nav hook
  const [basicKeyDownNav, dropdownKeyDownNav] = useKeyboardNavigation({
    focusRef,
    refList,
    showDropdown,
    toggleDropdown: setShowDropdown,
  });
  const travelBasicKeyDownNav = basicKeyDownNav;
  const travelKeyDownNav = dropdownKeyDownNav;

  const _handleTravelSelection = (option) => {
    setFilterState({
      ...filterState,
      commuteMode: option,
    });

    setShowDropdown(false);
  };

  const handleTravelModeButtonClick = useYieldCallback(() => {
    setShowDropdown(!showDropdown);
    toggleDepartureDropdown(false);
  });

  const handleTravelModeButtonKeyDown = (e) => travelBasicKeyDownNav(e.keyCode);

  const handleTravelModeOptionClick = (e) => {
    const option = e.currentTarget.getAttribute('data-option-value');

    // Guard against null/undefined option
    if (!option) return;

    _handleTravelSelection(option);
  };

  const handleTravelModeOptionKeyDown = (e) => {
    e.stopPropagation();

    const keyCode = e.keyCode;
    const enterKeyPressed = keyCode === 13;
    const option = e.currentTarget.getAttribute('data-option-value');

    // Guard against null/undefined option
    if (!option) return;

    if (enterKeyPressed) {
      _handleTravelSelection(option);
    } else {
      travelKeyDownNav(e.keyCode);
    }
  };

  return {
    handleTravelModeButtonClick,
    handleTravelModeButtonKeyDown,
    handleTravelModeOptionClick,
    handleTravelModeOptionKeyDown,
  };
};

export const useDepartureDropdown = ({
  focusRef,
  refList,
  showDropdown,
  setShowDropdown,
  filterState,
  setFilterState,
  toggleTravelModeDropdown,
}) => {
  // General keyboard nav hook
  const [basicKeyDownNav, dropdownKeyDownNav] = useKeyboardNavigation({
    focusRef,
    refList,
    showDropdown,
    toggleDropdown: setShowDropdown,
  });
  const departureBasicKeyDownNav = basicKeyDownNav;
  const departureKeyDownNav = dropdownKeyDownNav;

  const _handleDepartureSelection = (option) => {
    setFilterState({
      ...filterState,
      commuteTimeMode: option,
    });

    setShowDropdown(false);
  };

  const handleDepartureButtonClick = useYieldCallback(() => {
    setShowDropdown(!showDropdown);
    toggleTravelModeDropdown(false);
  });
  const handleDepartureButtonKeyDown = (e) => departureBasicKeyDownNav(e.keyCode);

  const handleDepartureOptionClick = (e) => {
    const option = e.currentTarget.getAttribute('data-option-value');

    // Guard against null/undefined option
    if (!option) return;

    _handleDepartureSelection(option);
  };

  const handleDepartureOptionKeyDown = (e) => {
    e.stopPropagation();

    const keyCode = e.keyCode;
    const enterKeyPressed = keyCode === 13;
    const option = e.currentTarget.getAttribute('data-option-value');

    // Guard against null/undefined option
    if (!option) return;

    if (enterKeyPressed) {
      _handleDepartureSelection(option);
    } else {
      departureKeyDownNav(e.keyCode);
    }
  };

  return {
    handleDepartureButtonClick,
    handleDepartureButtonKeyDown,
    handleDepartureOptionClick,
    handleDepartureOptionKeyDown,
  };
};

export const useAutocompleteDropdown = ({ focusRef, refList, showDropdown, toggleDropdown }) => {
  const [basicKeyDownNav, dropdownKeyDownNav, resetCurrentIdx] = useKeyboardNavigation({
    focusRef,
    refList,
    showDropdown,
    toggleDropdown,
  });
  const autocompleteBasicKeyDownNav = basicKeyDownNav;
  const autocompleteKeyDownNav = dropdownKeyDownNav;
  const autocompleteResetCurrentIdx = resetCurrentIdx;

  return [autocompleteBasicKeyDownNav, autocompleteKeyDownNav, autocompleteResetCurrentIdx];
};
